<template>
  <q-input
    v-model="value"
    class="san-field san-field--input"
    :type="isVisiblePassword ? 'text' : type"
    rounded
    outlined
    :color="color"
    no-error-icon
    :stack-label="$attrs.dense"
    :error-message="errorMessage"
    :error="!!errorMessage"
  >
    <template
      v-for="(slot, slotName) in $slots"
      #[slot]="scope"
      :key="slotName"
    >
      <slot
        :name="slotName"
        v-bind="scope || {}"
      />
    </template>

    <template
      v-if="name === 'password' || name === 'passwordConfirmation'"
      #append
    >
      <q-icon
        :name="isVisiblePassword ? 'mono-eye-closed' : 'mono-eye'"
        class="cursor-pointer"
        @click="isVisiblePassword = !isVisiblePassword"
      >
        <Tooltip
          anchor="center right"
          self="center left"
        >
          {{ t('common:Form.action.showPassword') }}
        </Tooltip>
      </q-icon>
    </template>
  </q-input>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useField } from 'vee-validate'
import { useTranslation } from 'i18next-vue'

defineOptions({ name: 'SanFieldInput' })
const props = defineProps({
  initialValue: { type: String, default: '' },
  name: { type: String, required: true },
  type: { type: String, default: 'text' },
  color: { type: String, default: 'primary-mid' }
})

const { t } = useTranslation()

const name = computed(() => props.name)
const { value, errorMessage, resetField, meta: { initialValue, dirty }, setValue, errors, setErrors, validate, ...rest } = useField(name, null, {initialValue:props.initialValue}) // eslint-disable-line

const isVisiblePassword = ref(false)

watch(() => value.value, async val => {
  // console.log(val, initialValue)
  if (val === initialValue) {
  // if (val === '' || val === null) {
    resetField()
    // resetField({ value: initialValue, errors: [] })
    // setErrors([])
    // await validate()
    // console.log('Errors after reset:', errorMessage.value)
    // console.log('Dirty after reset:', dirty)
  }
})

</script>
